var upperCase = require('upper-case')

/**
 * Upper case the first character of a string.
 *
 * @param  {String} str
 * @return {String}
 */
module.exports = function (str, locale) {
  if (str == null) {
    return ''
  }

  str = String(str)

  return upperCase(str.charAt(0), locale) + str.substr(1)
}



/*****************
 ** WEBPACK FOOTER
 ** ./~/pascal-case/~/upper-case-first/upper-case-first.js
 ** module id = 161
 ** module chunks = 0
 **/